import React, { useState } from "react";
import { Form, Button, Alert, Image, Spinner } from "react-bootstrap";
import "../components/Login.css";

import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';

import { setCredentials } from "../features/auth/authSlice";
import { useLoginMutation } from "../features/auth/authApiSlice";
import headLogo from "../static/img/headlogo.webp";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [login, { isLoading }] = useLoginMutation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    if (!email) newErrors.email = "Username is required";
    else if (email.length < 3) newErrors.email = "Username is invalid";
    if (!password) newErrors.password = "Password is required";
    else if (password.length < 6)
      newErrors.password = "Password must be at least 6 characters";
    return newErrors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      setErrors({});
      try {
        const userData = await login({ username: email, password }).unwrap();
        if (userData.status === "SUCCESS") {
          const roleId = userData.data?.accessData?.[0]?.roleId;
          dispatch(setCredentials({ ...userData, email }));
          if (roleId === 6) {
            navigate('admin/orders/pending'); // Adjust this if your route is different
          } else {
            navigate('/');
          }
        } else {
          setErrors({ common: userData.message });
        }
      } catch (error) {
        setErrors({ common: "Login failed. Please try again." });
      }
    }
  };

  return (
    <div className="login-wrapper">
      {/* Optional overlay while loading */}
      {isLoading && (
        <div className="loading-overlay">
          <Spinner animation="border" variant="primary" />
          <p className="loading-text">Logging in, please wait...</p>
        </div>
      )}

      <div className="login-form-container">
        <div className="login-title">
          <Image className="headimg" src={headLogo} />
        </div>
        {errors.common && <Alert variant="danger">{errors.common}</Alert>}
        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Username </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isInvalid={!!errors.email}
              disabled={isLoading}
            />
            <Form.Control.Feedback type="invalid">
              {errors.email}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password </Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              isInvalid={!!errors.password}
              disabled={isLoading}
            />
            <Form.Control.Feedback type="invalid">
              {errors.password}
            </Form.Control.Feedback>
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            className="login-button"
            disabled={isLoading}
            style={{ cursor: isLoading ? "not-allowed" : "pointer" }}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default Login;
